import serverCall from "../../serverCall";

const createImage = async (data) => {
  try {
    const response = await serverCall.post(`/images/admin/HDR`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const AddHDRImageService = {
  createImage,
};

export default AddHDRImageService;
